import $ from 'jquery';
import config from '../config.mjs';
import template from '../../handlebar-templates/alert.hbs';

export default class Alert {
  /**
   * @param {Object} data JSON object
   * @returns {Window.jQuery|HTMLElement|*}
   */
  constructor(data) {
    return $(template({
      "imageDirectoryPath": config.imageDirectoryPath,
      ...data,
    }));
  }
}
